import { Spinner } from "@heroui-v3/react";

export const LimeLoader = () => {
  return (
    <div className="flex h-[80%] items-center justify-center">
      <Spinner color="accent" size="lg" />
    </div>
  );
};
